import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../../HomePage/Faq/Faq.css";
const BirthCertAttestationFaMain = () => {
      useEffect(() => {
        AOS.init({
          duration: 600,
        });
      }, []);
  return (
    <div>
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                What is Birth Certificate Attestation and why is it required?{" "}
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              Birth Certificate Attestation is the process of verifying a birth
              certificate so it is accepted by foreign authorities. You need it
              for:
              <ul>
                <li> Family/Dependent Visa</li>
                <li> Child Visa (UAE, Qatar, Oman, Kuwait, Saudi)</li>
                <li> School Admission Abroad</li>
                <li> Migration/PR</li>
                <li> Medical or Legal purposes overseas</li>
              </ul>
              Without attestation, the birth certificate will not be accepted
              internationally.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Which countries require Birth Certificate Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Most commonly:
              <ul>
                <li> UAE</li>
                <li> Qatar</li>
                <li> Kuwait</li>
                <li> Saudi Arabia</li>
                <li> Oman</li>
                <li> Bahrain</li>
              </ul>
              For European countries, USA, or other Hague Convention nations →
              Apostille is required instead of Embassy Attestation.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                What documents are required for Birth Certificate Attestation?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You will need:
              <ul>
                <li> Original Birth Certificate</li>
                <li> Passport copy of the child and parents</li>
                <li> Aadhar or ID proof</li>
                <li> Photocopy of visa (if available)</li>
                <li> Authorization letter (if using an agency)</li>
              </ul>
              The certificate must be non-laminated, clear, and
              government-issued.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                What is the attestation process for a Birth Certificate in
                Bangalore?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              The standard process is:
              <ul>
                <li> Notary Attestation</li>
                <li> State Home Department or SDM Attestation</li>
                <li> MEA (Ministry of External Affairs) Attestation</li>
                <li>
                  Embassy Attestation (UAE, Qatar, Kuwait, Saudi, Oman, Bahrain)
                </li>
                <li> MOFA Attestation at the destination country</li>
              </ul>
              This ensures the document is legally valid overseas.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does Birth Certificate Attestation take?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Timelines vary based on the country:
              <ul>
                <li>
                  {" "}
                  <b>UAE / Qatar / Oman:</b> 5–10 working days
                </li>
                <li>
                  <b> Kuwait:</b> 7–12 working days
                </li>
                <li>
                  {" "}
                  <b>Saudi Arabia: </b>10–16 working days
                </li>
                <li>
                  {" "}
                  <b>Apostille countries:</b> 1–3 working days
                </li>
              </ul>
              Express services may be available depending on embassy workload.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                How much does Birth Certificate Attestation cost in Bangalore?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Costs depend on:
              <ul>
                <li> Country</li>
                <li> Embassy fees</li>
                <li> Govt fees (MEA, State)</li>
                <li> Urgency</li>
                <li> Courier & service charges</li>
              </ul>
              <br />
              Typical price ranges:
              <ul>
                <li> Gulf Countries: ₹2,500 – ₹9,000</li>
                <li> Apostille: ₹1,500 – ₹3,000</li>
              </ul>
              Always ask for a transparent pricing breakdown.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is it safe to hand over original Birth Certificates?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—if you use a Government-approved, ISO-certified attestation
              agency. Ensure that the agency provides:
              <ul>
                <li> Receipt/acknowledgment</li>
                <li> Document tracking</li>
                <li> Office address verification</li>
                <li> WhatsApp/SMS updates</li>
              </ul>
              Avoid freelancers or unofficial agents.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Can Birth Certificate Attestation be done without visiting the
                office?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Many Bangalore agencies offer:
              <ul>
                <li> Free home pickup & drop</li>
                <li> Online payment</li>
                <li> WhatsApp document submission</li>
                <li> Full tracking and support</li>
              </ul>
              This is very convenient for parents with infants or busy
              schedules.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Are laminated Birth Certificates accepted for attestation?{" "}
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              <b> No.</b>Do NOT submit laminated certificates. You must:
              <ul>
                <li> Remove lamination carefully, OR</li>
                <li>
                  Apply for a fresh reissued Birth Certificate from
                  BBMP/Registrar
                </li>
              </ul>
              Laminated documents can be rejected by MEA or Embassy.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                {" "}
                10. What common issues cause delays or rejection of Birth
                Certificate Attestation?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Major problems include:
              <ul>
                <li> Name mismatch between certificate & passport</li>
                <li> Handwritten or old-format certificates</li>
                <li> Mother’s or father’s name not fully mentioned</li>
                <li> Damaged or laminated documents</li>
                <li> Incorrect place/date of birth</li>
                <li> Missing government seal</li>
              </ul>
              A good agency pre-verifies your documents to avoid delays
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default BirthCertAttestationFaMain;
